const environmentForm = {
  layout: {
    layout: 'vertical',
  },

  validationMessages: {
    required: 'form.error.required',
  },

  fields: [
    {
      label: 'users.form.selectEnviroment',
      name: 'enviromentId',
      type: 'select',
      showSearch: true,
      allowClear: true,
      lazy: true,
      remote: true,
      nomenclature: true,
      noResetApiData: true,
      apiRoute: 'environment/paged',
      labelInValue: true,
      params: {
        select: 'id,name',
        filter: 'isActive eq true',
        orderBy: 'name',
      },
      options: [],
      required: true,
    },
  ],
};

export default { environmentForm };
